/**
 * External Dependencies
 */
import 'jquery';
import 'alpinejs'
import Rellax from 'rellax';
import barba from '@barba/core';
import smoothscroll from 'smoothscroll-polyfill';
import { beforeEnterWp } from './page-transitions'
import { useSwiper } from './slider'
import useTimelineMap from './investment-timeline-map'

// Make element scrolling behavior predictable, mainly Safari
smoothscroll.polyfill();

/** 
 * Dispatch Custom Event
 * 
 * Works great with Alpine.js
 */
const dispatch = (event = 'dispatch', detail = {}, recipient = window) => {
  recipient.dispatchEvent(new CustomEvent(event, { detail }))
}

// Cache the main DOM elements
const nav = document.getElementById('nav');
const navSticker = document.getElementById('nav-stuck-trigger');
const adminbar = document.getElementById('wpadminbar');

// Sticky nav stuff
const stickyChange = stuck => dispatch('sticky-change', { stuck }, nav)
const stickyObserver = new IntersectionObserver(([e]) => stickyChange(e.intersectionRatio < 1));
stickyObserver.observe(navSticker);

// Core Library Instantiation
let swiper, rellax;
const initSwiper = () => { swiper = useSwiper() }
const initRellax = () => {
  rellax = Rellax('.rellax');
  window.setTimeout(() => window.requestAnimationFrame(() => rellax?.refresh?.()), 500)
}

// Timeline Map
let timelineMap;
const initTimelineMap = () => {
  const timelineMapEl = document.getElementById('investment-timeline')
  const timelineRangeEl = document.getElementById('investment-timeline-range')
  const viewAllButton = document.getElementById('investment-timeline-view-all')
  
  if (timelineMapEl) {
    timelineMap = {};
    useTimelineMap(timelineMapEl)
      .then(timelineMapInstance => {
        console.log(timelineMapInstance)
        timelineMap = timelineMapInstance;
        timelineRangeEl?.addEventListener?.('input', timelineMap.onRangeInput)
        viewAllButton?.addEventListener?.('click', timelineMap.viewAllMarkers)
      })
      .catch(rejection => {
        console.log(rejection)
        timelineMap = null;
      })
  }
}

/**
 * Anything you usually do on page load or jQuery.ready() should be executed here
 */
const initPageActivities = () => {
  // console.log(swiper, rellax)
  if (!swiper) initSwiper()
  if (!rellax) initRellax()
  if (!timelineMap) initTimelineMap()
}

const readyPageActivities = () => {
  if (!timelineMap) initTimelineMap()
}

/** 
 * Release event listeners, free up memory
 */
const destroyPageActivities = () => {
  rellax?.destroy?.()
  rellax = null

  swiper?.destroy?.()
  swiper = null

  timelineMap?.destroy?.()
  timelineMap = null
}

/*
const numberBlocks = document.querySelectorAll('section span[data-val]')
if (numberBlocks?.length) {
  const easeOutCirc = (x = 0) => Math.sqrt(1 - Math.pow(x - 1, 2))
  const animateNumber = el => {
    if (el?.dataset?.playing) return

    let frame = 0;
    let frameTarget = Math.round(2000 / 16)
    let desiredVal = parseFloat(el?.dataset?.val) || 100
    const toFigure = Number.isInteger(desiredVal)
      ? 0
      : desiredVal.toString().replace(/.*\./,'').length || 0

    const run = () => {
      if (frame < frameTarget) {
        requestAnimationFrame(() => {
          frame++
          const easeVal = easeOutCirc(frame / frameTarget);
          const newVal = easeVal * desiredVal
          el.dataset.playing = true
          el.innerText = Math.round(newVal * (10 * (1 + toFigure))) / (10 * (1 + toFigure)
          run()
        })
      } else {
        el.dataset.playing = false
      }
    }

    run()
  }

  const blockViewportCheck = new IntersectionObserver(([e]) => {
    if (e.intersectionRatio >= 1) {
      animateNumber(e.target);
      console.log('animating', e.target, animateNumber)
    }
  });

  [...numberBlocks].forEach(numBlock => blockViewportCheck.observe(numBlock));
}
*/

/** Most of what you see here are implementation details for Barba.js */
$(() => {
  initPageActivities()

  // Ensure WP adminbar isn't affected by Barba
  if (adminbar?.dataset) { adminbar.dataset.barbaPrevent = 'all' }
  if (document.scrollingElement?.scrollTop ?? 0 > 50) stickyChange(true);

  barba.init({
    transitions: [{
      name: 'default-transition',
      leave() {
        const done = this.async();
        dispatch('pageleave');
        setTimeout(done, 950);
      },
      enter(data) {
        const done = this.async();
        data.current.container.style.display = 'none';
        dispatch('pageenter');
        setTimeout(done, 950);
      },
    }],
  });

  barba.hooks.beforeLeave(() => {
    dispatch('pagebeforeleave')
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  })

  barba.hooks.afterLeave(() => {
    destroyPageActivities()
  })

  barba.hooks.beforeEnter(({ current, next }) => {
    swiper = null
    rellax = null

    dispatch('pagenav', { page: next?.url?.href, path: next?.url?.path })
    dispatch('pagebeforeenter')
    beforeEnterWp(current, next)
  })

  barba.hooks.afterEnter(() => {
    initPageActivities()
  });

  barba.hooks.after(() => {
    window?.ga?.('set', 'page', window.location.pathname);
    window?.ga?.('send', 'pageview');

    if (window.location.hash) {
      document.querySelector(window.location.hash)?.scrollIntoView?.({ behavior: 'smooth' });
    }

    readyPageActivities();
  });

  readyPageActivities()
});
